module.exports = __webpack_public_path__ + "img/renaming_module.png";